
export default {
  props: {
    isMultiline: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    intermediateData: '',
  }),
  computed: {
    textData: {
      get() {
        return this.value.trim();
      },
      set(newValue) {
        if (this.intermediateData !== newValue) {
          this.intermediateData = newValue;
        }
        if (this.value !== newValue) {
          this.$emit('input', newValue);
        }
      },
    },
  },
  methods: {
    saveOnEnter(event) {
      if (!this.isMultiline || !event.shiftKey) {
        event.preventDefault();
        this.$refs.editableText.blur();
      }
    },
    cancelOnEsc() {
      this.save(this.intermediateData);
      this.$refs.editableText.blur();
    },
    saveOnBlur() {
      const { innerText } = this.$refs.editableText;
      const innerTextTrimmed = innerText.trim();
      this.save(innerTextTrimmed, innerText);
      this.$refs.editableText.scrollLeft = 0;
    },
    save(newValue, prevValue) {
      if (newValue !== prevValue) {
        this.$refs.editableText.innerText = newValue;
      }
      this.textData = newValue;
    },
  },
  mounted() {
    if (this.textData) {
      this.$refs.editableText.innerText = this.textData;
      this.intermediateData = this.textData;
    }
  },
  watch: {
    textData(newValue) {
      if (newValue !== this.intermediateData) {
        this.$refs.editableText.innerText = newValue;
        this.intermediateData = newValue;
      }
    },
  },
};
